export default "__VITE_ASSET__DFV$VItO__"